import { CrudModel } from './crud/crud.model';

export class CountryModel extends CrudModel<CountryModel> {
    countryId: string;
    countryNameNl: string;
    countryNameEn: string;
    iso3: string;
    protected readonly excluded: string[] = ['adminGroup'];
}
